<template>
  <div class="header" :class="[themeColor]">
    <div class="logo">
      <a href="/">
        <img class="image" src="../assets/images/logo.png" alt="" />
      </a>
    </div>
    <ul class="navbar">
      <router-link to="/" exact v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">主页</a>
        </li>
      </router-link>
      <router-link
        exact
        :to="
          state.keyword
            ? { path: '/jobs', query: { keyword: state.keyword } }
            : '/jobs'
        "
        v-slot="{ href, navigate, isActive }"
      >
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">职位</a>
        </li>
      </router-link>
      <router-link to="/companys" v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">公司</a>
        </li>
      </router-link>
      <router-link to="/policy" v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">引才政策</a>
        </li>
      </router-link>
      <router-link
        exact
        :to="{
          path: '/announcement',
          query: { announcementId: state.announcementId },
        }"
        v-slot="{ href, navigate, isActive }"
      >
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">新闻中心</a>
          <ul
            class="p_level2Box"
            style="
              height: 200px;
              padding-top: 15px;
              margin-top: 0px;
              padding-bottom: 15px;
              margin-bottom: 0px;
            "
          >
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '1' },
                  }"
                >
                  <span>集团动态</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '2' },
                  }"
                >
                  <span>招聘公告</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '3' },
                  }"
                >
                  <span>考试通知</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '4' },
                  }"
                >
                  <span>党建文化</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '9' },
                  }"
                >
                  <span>媒体聚焦</span>
                </router-link>
              </p>
            </li>
          </ul>
        </li>
      </router-link>
      <router-link
        exact
        :to="{
          path: '/servicehall',
          query: { servicehallId: state.servicehallId },
        }"
        v-slot="{ href, navigate, isActive }"
      >
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">服务大厅</a>
          <ul
            class="p_level2Box"
            style="
              height: 340px;
              padding-top: 15px;
              margin-top: 0px;
              padding-bottom: 15px;
              margin-bottom: 0px;
            "
          >
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '1' },
                  }"
                >
                  <span>高端人才</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '2' },
                  }"
                >
                  <span>招聘引才</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '3' },
                  }"
                >
                  <span>考试测评</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '4' },
                  }"
                >
                  <span>干部教育</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '5' },
                  }"
                >
                  <span>人才培训</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '6' },
                  }"
                >
                  <span>管理咨询</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '7' },
                  }"
                >
                  <span>园区运营</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '8' },
                  }"
                >
                  <span>派遣外包</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/servicehall',
                    query: { servicehallId: '9' },
                  }"
                >
                  <span>股权激励基金</span>
                </router-link>
              </p>
            </li>
          </ul>
        </li>
      </router-link>
      <router-link
        exact
        :to="{ path: '/aboutUs', query: { aboutUsId: state.aboutUsId } }"
        v-slot="{ href, navigate, isActive }"
      >
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">关于我们</a>
          <ul
            class="p_level2Box"
            style="
              height: 200px;
              padding-top: 15px;
              margin-top: 0px;
              padding-bottom: 15px;
              margin-bottom: 0px;
            "
          >
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{ path: '/aboutUs', query: { aboutUsId: '1' } }"
                >
                  <span>集团简介</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{ path: '/aboutUs', query: { aboutUsId: '2' } }"
                >
                  <span>产品体系</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{ path: '/aboutUs', query: { aboutUsId: '3' } }"
                >
                  <span>组织架构</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{ path: '/aboutUs', query: { aboutUsId: '4' } }"
                >
                  <span>信息公开</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{ path: '/aboutUs', query: { aboutUsId: '5' } }"
                >
                  <span>广告投放</span>
                </router-link>
              </p>
            </li>
          </ul>
        </li>
      </router-link>
    </ul>
    <span>|</span>
    <div class="user">
      <div class="login" v-if="!state.isLogin">
        <router-link to="/user">
          <span class="login__text" style="margin-right: 20px">找工作</span>
        </router-link>
        <a href="https://zp.hubeipeople.com/" target="_blank"
          ><span class="login__text">找人才</span></a
        >
      </div>

      <div class="dropdown-menu" v-else>
        <span class="dropdown-menu__email">
          {{ state.userName || state.phoneNumber }}
          <i class="arrow"></i>
        </span>
        <ul class="dropdown-menu__wrapper">
          <li class="dropdown-menu__item">
            <router-link to="/resume">我的简历</router-link>
          </li>
          <li class="dropdown-menu__item">
            <router-link to="/jobSearchProgress">求职进展</router-link>
          </li>
          <li class="dropdown-menu__item" @click="handleLogout">退出</li>
        </ul>
      </div>
    </div>
    <div class="feedback">
      <router-link to="/feedback" class="back">
        <img src="../assets/images/index20231114_2.png" alt="" />
      </router-link>
      <router-link
        :to="{ path: '/aboutUs', query: { aboutUsId: '4' } }"
        class="back"
        ><img src="../assets/images/index20231114_3.png" alt=""
      /></router-link>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import { removeToken } from "@/helper/auth";
export default {
  name: "Header",
  data: () => ({
    state: store.state,
  }),
  props: {
    themeColor: {
      type: String,
      default: "main-color",
    },
  },
  created() {
    // this.state = JSON.parse(localStorage.getItem("account"));
  },
  methods: {
    handleLogout() {
      removeToken();
      store.expireLogin();
      sessionStorage.clear();
      this.$router.push("/home");
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: "DingTalk-JinBuTi";
  // src: url(../assets/fonts/DingTalk-JinBuTi.woff2) format("woff2");
  font-weight: 400;
  font-style: normal;
}

.header {
  min-width: @main-width;
  width: 100%;
  padding: 0 2%;
  margin: auto;
  color: #333;
  font-family: "DingTalk-JinBuTi";
  display: flex;
  height: 80px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  background: #fff;
  box-shadow: 0px 5px 10px 0px #c2c1c180;
  z-index: 999;
  &.main-color {
    background-color: #fff;
    .navbar-item {
      &:hover {
        color: @main-color;
      }
      &:hover > ul {
        display: block;
      }
    }

    .navbar-item:hover::before {
      color: #00a0e9;
      opacity: 1;
      bottom: 0px;
    }
    .login-text {
      color: @main-color;
    }
  }
  &.is-transparent {
    color: #333;
    .navbar-item {
      &:hover {
        color: @main-color;
      }
      &:hover > ul {
        display: block;
      }
    }
    .navbar-item:hover::before {
      color: #00a0e9;
      opacity: 1;
      bottom: 0px;
    }
    .active {
      color: @main-color;
    }
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    height: 100%;
    display: block;
    img {
      width: 30vw;
      height: auto;
    }
  }
}

.navbar {
  margin-left: auto;
  margin-right: 20px;
  font-size: 1vw;
  display: flex;
  &-item {
    padding: 28px 0px;
    margin: 0 12px;
    position: relative;
    &.active {
      color: @main-color;
    }
    .p_level2Box {
      display: none;
      height: auto;
      padding: 15px 0;
      background: #00a0e9;
      width: 130px;
      position: absolute;
      left: 50%;
      top: 100%;
      z-index: 1100;
      transform: translateX(-50%);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .p_level2Item {
        position: relative;
        width: 100%;
        a {
          font-size: 15px;
          padding: 0 10px;
          line-height: 35px;
          display: block;
          text-align: center;
          color: #666;
          opacity: 1;
          transition: all ease 0.3s;
        }
        a {
          color: rgba(255, 255, 255, 0.8);
        }

        a:hover {
          color: #fff;
        }
      }
    }
  }
  &-item::before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    border: 8px solid;
    border-color: transparent transparent #00a0e9 transparent;
    opacity: 0;
    // transition: all 0.5s ease;
  }
}
.user {
  margin-left: 34px;
  position: relative;
  font-size: 1vw;
  .arrow {
    display: inline-block;
    border: 1px solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
    transform-origin: center;
    vertical-align: 5px;
    margin-left: 5px;
    transition: all 0.3s;
    width: 10px;
    height: 10px;
  }
  &:hover {
    .arrow {
      transform: rotate(-45deg);
      vertical-align: -3px;
    }
    .dropdown-menu__wrapper {
      display: block;
    }
  }
  .dropdown-menu {
    position: relative;
    z-index: 1000;
    &__email {
      line-height: 2;
      cursor: pointer;
    }
    &__wrapper {
      position: absolute;
      display: none;
      right: 0;
      color: @regular-text-color;
      padding: 9px 0;
      width: 200px;
      border-radius: 5px;
      box-shadow: 0 0px 2px 1px #eee;
      background: #fff;
    }
    &__item {
      padding: 9px 12px;
      cursor: pointer;
      &:hover {
        background: #efefef58;
      }
    }
  }
}
.feedback {
  margin-left: 40px;
  .back {
    margin: 5px;
    img {
      width: 25px;
    }
  }
}

@media (max-width: 1680px) {
  .logo a img {
    width: 390px;
    height: auto;
  }
  .navbar {
    font-size: 16px;
  }
  .user {
    font-size: 16px;
  }
}

@media (max-width: 1560px) {
  .header {
    padding: 0;
  }
  .logo a img {
    width: 330px;
    height: auto;
  }
  .navbar {
    font-size: 15px;
  }
  .user {
    font-size: 15px;
  }
}

@media (max-width: 1400px) {
  .header {
    padding: 0;
  }
  .logo a img {
    width: 270px;
    height: auto;
  }
  .navbar {
    font-size: 14px;
  }
  .user {
    font-size: 14px;
  }
}

@media (max-width: 1300px) {
  .header {
    padding: 0;
  }
  .logo a img {
    width: 270px;
    height: auto;
  }
  .navbar {
    font-size: 14px;
  }
  .user {
    font-size: 14px;
  }
}
</style>
